module.exports = __webpack_public_path__ + "../resources/images/illustration_folder-e3f19c17b87b896402c10b522460dd57.svg";